import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ResponsiveImg from '../../shared/ResponsiveImg';

import styles from './Triple.module.postcss';

function Triple({ image, text, title, link, isResponsive = false }) {
  if (link) {
    return (
      <div className={styles.Triple}>
        <Link to={link} >
          { !isResponsive &&
          <img className={styles.TripleImg} src={image} alt='' loading='lazy' />
          }
          { isResponsive &&
            <ResponsiveImg
              className={styles.TripleImg}
              src={image}
              widths={[400, 600, 800]}
              sizes='(max-width: 900px) 100vw, 33vw'
              alt=''
              loading='lazy'
            />
          }
          <h3>{title}</h3>
          <p>{text}</p>
        </Link>
      </div>
    );
  }

  return (
    <div className={styles.Triple}>
      { !isResponsive &&
        <img className={styles.TripleImg} src={image} alt='' loading='lazy' />
      }
      { isResponsive &&
        <ResponsiveImg
          className={styles.TripleImg}
          src={image}
          widths={[400, 600, 800]}
          sizes='(max-width: 900px) 100vw, 33vw'
          alt=''
          loading='lazy'
        />
      }
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
}

Triple.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  link: PropTypes.string,
};

export default Triple;
